<template>
  <!-- 主动进入患者用户需输入医师邀请码进入 -->
  <div class="code-binding-wrapper">
    <div class="binding-header">
      <div class="link-item"><img :src="userInfo.avatar"></div>
      <div class="link-mid"><img src="@/assets/images/user-link.png"></div>
      <div class="link-item"><img src="@/assets/images/logo.png"></div>
    </div>
    <div class="linked-main">
      <div class="link-input" @touchstart.stop="keyBoardShow = true">
        <span class="placeholder" v-if="!doctorCode">请输入医生邀请码</span>
        <span class="value" v-else>{{doctorCode}}</span>
      </div>
      <div class="link-submit"><button class="bind-button" @click="bindDoctor">确定</button></div>
      <div class="scan-qrcode" @click="startScan"><icon icon-class="scan"></icon>扫描二维码</div>
    </div>

    <van-number-keyboard
      v-model="doctorCode"
      :show="keyBoardShow"
      :maxlength="8"
      @blur="keyBoardShow = false"
    />
  </div>
</template>

<style lang="less" scoped>
  .code-binding-wrapper{
    .binding-header{
      width: 100%;
      height: 136px;
      background: @linear;
      display: flex;
      justify-content: center;
      align-items: center;
      .link-mid{
        width: 132px;
        margin-top: 2px;
        img{
          width: 100%;
        }
      }
      .link-item{
        width: 68px;
        height: 68px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid #FFF;
        border-radius: 50%;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1);
        margin: 0 10px;
        background: #FFF;
        color: @xile;
        font-weight: bold;
        overflow: hidden;
        img{
          width: 100%;
        }
      }
    }
    .linked-main{
      padding: 48px 56px 0;
      .link-input{
        width: 195px;
        height: 48px;
        line-height: 48px;
        font-size: 14px;
        background: #F3F3F3;
        margin: 0 auto;
        text-align: center;
        .placeholder{
          color: #999;
        }
        .value{
          color: @black;
        }
      }
      .link-submit{
        width: 100%;
        margin-top: 40px;
        .bind-button{
          @button-base();
          width: 100%;
          height: 36px;
          font-size: 14px;
        }
      }
      .scan-qrcode{
        margin-top: 24px;
        font-size: 15px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666;
        svg{
          position: relative;
          top: -1px;
          font-size: 14px;
          margin-right: 6px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        doctorCode: '',
        keyBoardShow: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      // 获取微信签名
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if(data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['scanQRCode']
          });
        }
      })
    },
    methods: {
      bindDoctor() {
        if(!this.doctorCode) {
          this.$notify('请输入医生邀请码');
          return;
        }
        this.$root.post('/validateCode', {
          code: this.doctorCode
        }).then(data => {
          console.log(data);
          if(data.status == 1) {
            this.$router.push({path: '/patient/binding', query: {doc_id: data.doc_id}});
          }else {
            this.$notify(data.msg);
          }
        })
      },
      startScan() {
        wx.scanQRCode({
          needResult: 0,
          scanType: ["qrCode"]
        });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/codeBinding.vue